module.exports = __webpack_public_path__ + "img/lugares.c0349b1e.jpg";